import React, { useEffect, useState } from "react";
import SummaryApi from "../common";
import noimage from "../asset/noimage.png";
import { useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { HiOutlineArrowRight } from "react-icons/hi";
import { RiBookmarkLine, RiShareBoxLine } from "react-icons/ri";
import { BsDot } from "react-icons/bs";
import { FaGraduationCap } from "react-icons/fa6";
import { PiStarFourFill } from "react-icons/pi";
import { useAuth } from "../helpers/AuthContext"; // Import useAuth
import { FaBookmark } from "react-icons/fa";
import Swal from "sweetalert2";

const Courses = () => {
  const navigate = useNavigate();
  const [coursesData, setCoursesData] = useState([]);
  const [savedCourseIds, setSavedCourseIds] = useState([]);
  const { studentId, studentName, setStudentName, logout } = useAuth();
  const student_id = studentId;

  useEffect(() => {
    fetch(SummaryApi.getActiveTrendyCourses.url)
      .then((res) => res.json())
      .then((data) => {
        if (data.status && data.data) {
          setCoursesData(data.data);
        }
      })
      .catch((err) => console.error("API error:", err));
  }, []);

  useEffect(() => {
    if (student_id) {
      fetch(SummaryApi.getSavedcourseStudentId.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ student_id }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status && data.data) {
            setSavedCourseIds(data.data); // Save entire saved course objects
          }
        })
        .catch((err) => console.error("Failed to fetch saved courses:", err));
    }
  }, [student_id]);

  const handleSaveCourse = (course_id) => {
    if (!student_id) {
      Swal.fire({
        icon: "warning",
        title: "Please log in first",
        text: "You need to be logged in to save courses.",
      });
      return;
    }
    if (savedCourseIds.find((c) => c.course_id === course_id)) {
      Swal.fire({
        icon: "info",
        title: "Already Saved",
        text: "This course is already in your saved list.",
      });
      return;
    }
    fetch(SummaryApi.SaveCourseToStudent.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ student_id, course_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSavedCourseIds((prev) => [
            ...prev,
            { course_id, saved_course_id: data.saved_course_id },
          ]);
          Swal.fire({
            muddy: "success",
            title: "Course Saved",
            text: "The course has been added to your saved list.",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Save Failed",
            text: data.message || "Failed to save the course.",
          });
        }
      })
      .catch((err) => {
        console.error("Error saving course:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while saving the course.",
        });
      });
  };

  const handleDeleteSavedCourse = (course_id) => {
    const savedCourse = savedCourseIds.find((c) => c.course_id === course_id);
    if (!savedCourse) return;
    fetch(SummaryApi.DeleteSavedCourse.url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ saved_course_id: savedCourse.saved_course_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setSavedCourseIds((prev) =>
            prev.filter((c) => c.course_id !== course_id)
          );
          Swal.fire({
            icon: "success",
            title: "Course Removed",
            text: "The course has been removed from your saved list.",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Remove Failed",
            text: data.message || "Failed to remove the saved course.",
          });
        }
      })
      .catch((err) => {
        console.error("Error deleting saved course:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while removing the saved course.",
        });
      });
  };

  // Only show first 3 courses
  const limitedCourses = coursesData.slice(0, 3);

  return (
    <div className="bg-gray-50 dark:bg-gray-900 min-h-screen py-12 px-4 sm:px-6 lg:px-8 text-gray-900 dark:text-white">
      {/* Premium Courses Button */}
      <div className="flex justify-center mb-2">
        <button className="bg-white dark:bg-gray-800 text-[#1c3664] dark:text-white font-semibold py-3 px-8 rounded-full shadow-lg border-[5px] border-[#1c3664] dark:border-gray-600">
          Trending Courses
        </button>
      </div>
      {/* Trending Courses Section */}
      <div className="text-center mb-16">
        <h2 className="text-[48px] font-extrabold text-[#1c3664] dark:text-white mb-4 text-inter">
          Trending Courses
        </h2>
        <p className="text-[22px] text-[#1c3664] dark:text-gray-300 max-w-4xl mx-auto font-medium">
          Explore our wide range of premium courses designed by industry experts
          to help you advance your career with cutting-edge skills and
          certifications
        </p>
      </div>
      {/* Course Cards */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {limitedCourses.map((course) => (
          <div
            key={course.course_id}
            className="bg-white dark:bg-gray-800 rounded-lg shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300"
          >
            {/* Course Image */}
            <div className="relative">
              <img
                className="w-full h-48 object-cover"
                src={
                  course.course_image1
                    ? `${SummaryApi.instructorCourseImage.url.replace(
                        "api",
                        ""
                      )}${course.course_image1.replace("/api", "")}`
                    : noimage
                }
                alt={course.course_title}
              />
              <div className="absolute top-[73%] left-4 bg-gray-100 dark:bg-gray-700 text-blue-700 dark:text-blue-400 px-3 rounded-full flex items-center py-3">
                <PiStarFourFill className="w-4 h-4 mr-1 text-yellow-500" />
                <span className="text-[14px] text-[#1c3664] dark:text-white font-medium">
                  Professional Certificate
                </span>
              </div>
            </div>
            {/* Course Content */}
            <div className="p-6">
              <h3 className="text-xl font-bold text-[#1c3664] dark:text-white mb-2 group-hover:text-[#100F36] dark:group-hover:text-gray-300 transition-colors duration-300">
                {course.course_title}
              </h3>
              <div className="flex items-center text-sm text-gray-600 dark:text-gray-400 mb-4">
                <div className="flex items-center text-yellow-500 font-semibold mr-4 bg-yellow-50 dark:bg-yellow-900/30 px-3 py-1 rounded-full">
                  <FaStar className="w-4 h-4 mr-1" />
                  {course.rating}
                </div>
                <div className="flex items-center space-x-2 ml-auto">
                  {savedCourseIds.find(
                    (c) => c.course_id === course.course_id
                  ) ? (
                    <FaBookmark
                      className="w-6 h-6 text-green-600 dark:text-green-400 cursor-pointer"
                      title="Remove Saved Course"
                      onClick={() =>
                        handleDeleteSavedCourse(course.course_id)
                      }
                    />
                  ) : (
                    <RiBookmarkLine
                      className="w-6 h-6 text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer"
                      title="Save Course"
                      onClick={() => handleSaveCourse(course.course_id)}
                    />
                  )}
                 
                  <RiShareBoxLine className="w-6 h-6 text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer" />
                </div>
              </div>
              <div className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/30 border border-blue-100 dark:border-blue-800 rounded-lg p-3 mb-6">
                <div className="flex items-center">
                  <FaGraduationCap className="w-6 h-6 text-blue-700 dark:text-blue-400 mr-2" />
                  <span className="text-blue-700 dark:text-blue-400 font-semibold text-base">
                    Duration
                  </span>
                </div>
                <span className="text-blue-700 dark:text-blue-300 font-bold text-lg">
                  {course.course_duration || "N/A"}
                </span>
              </div>
              <div className="mt-6">
                <h4 className="font-bold text-[#1c3664] dark:text-white mb-2">
                  Course Details
                </h4>
                <ul className="text-sm text-[#1c3664] dark:text-gray-300 space-y-1">
                  <li className="flex items-start">
                    <BsDot className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0 mt-0.5" />
                    <span>Total Lessons: {course.total_lessons || "N/A"}</span>
                  </li>
                  <li className="flex items-start">
                    <BsDot className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0 mt-0.5" />
                    <span>
                      Level: {course.diffculty_level || "Not specified"}
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BsDot className="w-5 h-5 text-gray-500 dark:text-gray-400 flex-shrink-0 mt-0.5" />
                    <span>
                      Language: {course.language_instruction || "N/A"}
                    </span>
                  </li>
                </ul>
              </div>
              {/* View Details Button */}
              <div className="mt-8">
                <button
                  onClick={() => {
                    const encodedId = btoa(course.course_id.toString());
                    navigate(`/all-courses/${encodedId}`);
                  }}
                  className="w-full bg-[#1C3664] hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-semibold py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors duration-300 flex items-center justify-center"
                >
                  View Details
                  <HiOutlineArrowRight className="w-4 h-4 ml-2" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* View More Button */}
      {coursesData.length > 3 && (
        <div className="flex justify-center mt-12">
          <button
            onClick={() => navigate("/trendy-courses")}
            className=" bg-[#1C3664] hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-700 text-white text-[12px] font-semibold py-3 px-8 rounded-full transition duration-300"
          >
            View More Courses
          </button>
        </div>
      )}
    </div>
  );
};

export default Courses;